var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "block-icon-price"
    ),
    React.createElement(
      "g",
      { id: "Layer_2", "data-name": "Layer 2" },
      React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M24 0a24 24 0 1 0 24 24A24 24 0 0 0 24 0zm3.31 37h-.1l-.37.07q-.49.1-1 .17l-.1 4.27h-4l-.1-4.28a9.15 9.15 0 0 1-5.21-2.35 9.65 9.65 0 0 1-2.59-6.26h4.84a4.52 4.52 0 0 0 1.12 3.21 5.12 5.12 0 0 0 3.94 1.63 5 5 0 0 0 1.08-.07 6.65 6.65 0 0 0 1.38-.31 4.35 4.35 0 0 0 1.3-.69 3.7 3.7 0 0 0 1-1.1 3.1 3.1 0 0 0 .38-1.56 2.66 2.66 0 0 0-.93-2.21 8.89 8.89 0 0 0-3.06-1.31L20.59 25l-.15-.06c-3.7-1.22-5.53-3-5.91-6a3.69 3.69 0 0 1-.09-.76v-.31-.14c0-3.74 3.38-6.78 7.23-7.05l.1-4.28h4l.1 4.34a12.67 12.67 0 0 1 2 .53 8.13 8.13 0 0 1 2.47 1.42A7.11 7.11 0 0 1 32.06 15a8.13 8.13 0 0 1 .78 3H28a3.91 3.91 0 0 0-1-2.38 4.07 4.07 0 0 0-2.17-1.05 6 6 0 0 0-1.32-.11 8.67 8.67 0 0 0-1 .06 9.83 9.83 0 0 0-1 .23 3.29 3.29 0 0 0-1.09.58 2.83 2.83 0 0 0-.77 1 3.13 3.13 0 0 0-.28 1.37 2.42 2.42 0 0 0 .8 1.94 6.07 6.07 0 0 0 2.54 1.07l2.13.51.89.22.47.12c.57.14 1.12.3 1.65.49l.32.12.51.2a10.76 10.76 0 0 1 1.48.72A7.06 7.06 0 0 1 34 29.55c0 3.59-3 6.6-6.69 7.45z", id: "Layer_1-2", "data-name": "Layer 1" })
    )
  );
});